import { useRef } from 'react';

export const useBeforeMount = (func: () => void) => {
  const funcCalledBeforeMount = useRef(false);

  if (!funcCalledBeforeMount.current) {
    funcCalledBeforeMount.current = true;

    func();
  }
};
